export default __webpack_public_path__ + "static/marketIntegrationMobile1-c2ece3b45b32069543f91e3c7341a96b.jpg";